import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from 'react-error-boundary';

// Add this basic error handler
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Failed to find root element');
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <Provider store={store}>
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <App />
          </ErrorBoundary>
        </Provider>
      </StrictMode>
    );
  } catch (error) {
    console.error('Failed to render app:', error);
    rootElement.innerHTML = 'Failed to initialize application';
  }
}
